import React from 'react';

import PropTypes from 'prop-types';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { SummaryMain, SummaryItemMain, SummaryItemLabel } from './css';

const getAccessoriesList = (hardware, isInstallationService) => {
  return Object.entries(hardware).reduce((acc, [hardwareName, hardwareDetails]) => {
    if (!isInstallationService && hardwareDetails.isAccessory && hardwareDetails.additionalQuantity > 0) {
      acc.push({ name: hardwareName, quantity: hardwareDetails.additionalQuantity });
    }
    if (isInstallationService && hardwareDetails.quantity && hardwareDetails.unitPrice > 0) {
      acc.push({ name: hardwareName, quantity: hardwareDetails.quantity });
    }
    return acc;
  }, []);
};

const AccessoriesTracker = ({ hardware, sectionText, isInstallationService }) => {
  const accessoriesList = getAccessoriesList(hardware, isInstallationService);

  if (accessoriesList.length === 0) return null;

  const {
    iotOrderDetailsSection: { labelAccessories }
  } = useLocalizedStringsContext();

  return (
    <div>
      <h4>{!sectionText ? labelAccessories : sectionText}</h4>
      <SummaryMain>
        {accessoriesList.map(item => (
          <SummaryItemMain>
            <SummaryItemLabel>{item.name}</SummaryItemLabel>
            <span>{item.quantity}</span>
          </SummaryItemMain>
        ))}
      </SummaryMain>
    </div>
  );
};

AccessoriesTracker.propTypes = {
  hardware: PropTypes.shape({}).isRequired,
  sectionText: PropTypes.string.isRequired,
  isInstallationService: PropTypes.bool.isRequired
};

export default AccessoriesTracker;
